import { useRouter } from 'next/router';

export const useLocales = () => {
  const { locales } = useRouter();

  return locales?.filter((l) => l !== 'default') ?? [];
};
